import React, { useEffect, useState } from "react";
import "./EditEventSuccessmodal.css";

const EditEventSuccessmodal = ({
  visible,
  onClose,
  onProceed,
  title = "Event Updated",
  description = "Your Event has been updated successfully! The changes are now live.",
  buttonText = "Proceed",
  imagePath = "/images/successModal.png",
  buttonColor = "#006400",
}) => {
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    if (visible) {
      setIsAnimating(true);
    }
  }, [visible]);

  const handleClose = () => {
    setIsAnimating(false);
    setTimeout(() => {
      onClose();
    }, 300);
  };

  const handleProceed = () => {
    setIsAnimating(false);
    setTimeout(() => {
      onProceed();
    }, 300);
  };

  if (!visible) return null;

  return (
    <div className={`success-modal-overlay ${isAnimating ? "active" : ""}`}>
      <div
        className={`success-modal-container ${
          isAnimating ? "fade-scale-in" : ""
        }`}
      >
        <button className="success-modal-close-button" onClick={handleClose}>
          ✕
        </button>

        <div className="success-modal-content-wrapper">
          <div className="success-modal-image-container">
            <img
              src={imagePath}
              alt="Success"
              className="success-modal-image"
            />
          </div>

          <div className="success-modal-text-container">
            <h2 className="success-modal-title">{title}</h2>
            <p className="success-modal-description">{description}</p>
          </div>

          <div className="success-modal-button-container">
            <button
              className="success-modal-proceed-button"
              style={{ backgroundColor: buttonColor }}
              onClick={handleProceed}
            >
              {buttonText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditEventSuccessmodal;